<template>
  <div class="flex flex-col mt-5 h-full">
    <p class="mb-1 font-serif text-xl text-center text-gray-700 md:text-2xl">
      Para enviar los pedidos
    </p>
    <TruckIcon class="shrink-0 self-center w-32 h-32 text-lk-green md:w-40 md:h-40" />
    <p class="text-base font-light text-center md:text-lg">
      <span class="font-normal">Recuerda</span>
      agendar un retiro para que podamos enviar tu pedido.
    </p>
    <button
      class="p-2 mt-auto text-sm text-lk-green hover:text-white hover:bg-lk-green rounded-md border border-lk-green md:text-base"
      type="button"
      @click="emit('update:modelValue', true)"
    >
      Continuar
    </button>
  </div>
</template>
<script lang="ts" setup>
import { TruckIcon } from '@heroicons/vue/24/outline';

interface SubOrderShipmentReminderProps {
  modelValue: boolean
}

defineProps<SubOrderShipmentReminderProps>();

const emit = defineEmits<{(e: 'update:modelValue', value: boolean): void}>();
</script>
